import { FC, useState, useEffect } from 'react'
import clsx from 'clsx'
import Link from 'next/link'

import CourseCard from 'components/cards/course-card/course-card'
import usePCWindow from 'hooks/usePCWindow'

import A from 'utils/metrics/analytic'
import { getAxiosCounted } from 'pages/api/axios'
import { Pathname } from 'constants/data'
import { ICourseType } from 'constants/types/course.types'
import { ScreenSize } from 'constants/media-constanst'
import { BASE_URL } from 'constants/url'
import { A_COURSE_CLICK_PROGRAM } from 'constants/analytic-data'

import styles from './course-nmo-recommend.module.scss'

interface INmoRecommend {
  noShowCourses?: number[]
  maxShowCards?: number
  title?: string
  blockWrapperMod?: string
  cardsWrapperMod?: string
  cardsMod?: string
}

const CourseNmoRecommend: FC<INmoRecommend> = ({
  noShowCourses,
  maxShowCards = 2,
  title = 'Вам может быть интересно',
  blockWrapperMod,
  cardsWrapperMod,
  cardsMod,
}) => {
  const [cards, setCards] = useState([])
  const isBigPC = usePCWindow(ScreenSize.big)

  const sendAnalytic = (courseId: number) => {
    A.setEvent(A_COURSE_CLICK_PROGRAM, { subSource: String(courseId) })
  }

  useEffect(() => {
    const getData = async () => {
      const allItems = await getAxiosCounted(
        `${BASE_URL.NMO_COURSE}?count=true&prerecording=false&limit=${9}&type=all&offset=0`
      )
      let counter_max_cards = 0
      const filterdCards = allItems.rows.filter((card: ICourseType) => {
        if (
          !card.available &&
          !noShowCourses?.includes(card.id) &&
          counter_max_cards < maxShowCards
        ) {
          counter_max_cards++
          return card
        }
      })

      setCards(filterdCards)
    }
    getData()
  }, [])

  if (cards.length === 0) return null

  return (
    <div className={clsx(styles.nmoRecommend, blockWrapperMod)}>
      {title && <div className={styles.title}>{title}</div>}
      <div className={clsx(styles.cardsWrapper, cardsWrapperMod)}>
        {cards.map((card: ICourseType) => {
          const url = `/${Pathname.NMO_COURSE}/${card.linkTranslation || card.id}`
          return (
            <div key={card.id} className={clsx(styles.cardWrapper, cardsMod)}>
              <Link href={url} key={card.linkTranslation} onClick={() => sendAnalytic(card.id)}>
                <CourseCard {...card} isPc={isBigPC} />
              </Link>
            </div>
          )
        })}
      </div>
    </div>
  )
}

export default CourseNmoRecommend
